.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  font-size: var(--font-size-xs-plus);
  line-height: 1.4;
  color: var(--text-secondary);
}

.panelOnNav {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 10px var(--space-4);
  font-size: var(--font-size-xs-plus);
  line-height: 1.4;
  color: var(--text-on-nav);
  border-top: 1px solid var(--nav-divider);
}

.name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.panelOnNav .name {
  color: var(--text-on-nav-active);
}

.role {
  color: inherit;
}

.signOut {
  padding: 0;
  font-size: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

.theme {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  margin-top: var(--space-1);
}

.themeLabel {
  flex: none;
}

/* Список тем наследует цвет подвала: на бордовой навигации он светлый, во всплывающем
   меню — обычный. Собственного цвета у него нет, поэтому переворачивать нечего. */
.themeSelect {
  flex: 1;
  min-width: 0;
  padding: 2px 4px;
  font-size: var(--font-size-xs-plus);
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: 1px solid currentcolor;
  border-radius: var(--radius-sm);
}

.themeSelect option {
  color: var(--text-primary);
  background: var(--bg-card);
}
